import { ApiService } from '../../../types/api';
import type { ApiHandlerContract } from '../../../types/handlers/api';
import type { SyncLogIdentifier, SyncLogStatus, SyncLogStatusWithErrors } from '../types';

export interface SyncLogIntegrationApiContract {
  status(): Promise<SyncLogStatus>;
  errors(): Promise<SyncLogStatusWithErrors>;
}

export class SyncLogIntegrationApi extends ApiService implements SyncLogIntegrationApiContract {
  private identifier: SyncLogIdentifier;

  constructor(api: ApiHandlerContract, identifier: SyncLogIdentifier) {
    super(api);
    this.identifier = identifier;
  }

  private get integration(): string {
    return this.identifier.integration === 'shopify_plus' ? 'shopify' : this.identifier.integration;
  }

  status(): Promise<SyncLogStatus> {
    return this.api.proxy({
      method: 'GET',
      path: '/v1/sync-log/{integration}/{data_type}',
      params: {
        integration: this.integration,
        data_type: this.identifier.dataType,
      },
    });
  }

  errors(): Promise<SyncLogStatusWithErrors> {
    return this.api.proxy({
      method: 'GET',
      path: '/v1/sync-log/{integration}/{data_type}/errors',
      params: {
        integration: this.integration,
        data_type: this.identifier.dataType,
      },
    });
  }
}
